/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

import type {BulkOperationsServices} from '../types/BulkOperationsServices';
import {DataGridApp} from '../types/DataGridApp';
import {DataGridPermissionKeysEnum} from '../types/DataGridPermissionKeysEnum';
import {UserOptionsQuery} from '../types/UserOptionsQuery';
import {EntityResourceResolver} from './EntityResourceResolver';

export type StartedExport = {
  exportId: string;
  gridCode: string;
};

export type EagGridConfigProviderProps = {
  // Identifies the host app so grid internals can gate app-specific features.
  app: DataGridApp;
  bulkOperations?: BulkOperationsServices;
  entityResourceResolver?: EntityResourceResolver;
  // function which returns absolute url for given share link, if it is not supplied, the share button will be hidden
  buildAbsoluteUrl?: (url: string) => string;
  /**
   * Host-supplied permission/options accessors. Despite the `use*` prefix these are NOT
   * passed-through React hooks in the problematic sense — they are stable functions the
   * host provides once at the provider boundary, and consumers invoke them at the top
   * level of their render (obeying the rules of hooks). Intentional design: consumers do
   * not import the host's hooks directly. Kept as-is to preserve the public provider API.
   */
  useGetUserOptions?: () => UserOptionsQuery;
  usePermissions: (props: {permissionKeys: DataGridPermissionKeysEnum[]}) => boolean[];
  handleExportSuccessfullyStarted?: (startedExport: StartedExport) => void;
};

export const [EagGridConfigProvider, useEagGridConfig, EagGridConfigReactContext] =
  createContext<EagGridConfigProviderProps>({
    strict: true,
    name: 'EagGridConfigProvider',
  });
